export default {
  'en-GB': {
    currency: {
      style: 'currency',
      currency: 'GBP',
      currencyDisplay: 'symbol',
    },
  },
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'symbol',
    },
  },
  'en-AE': {
    currency: {
      style: 'currency',
      currency: 'AED',
      currencyDisplay: 'symbol',
    },
  },
  'en-ZA': {
    currency: {
      style: 'currency',
      currency: 'ZAR',
      currencyDisplay: 'symbol',
    },
  },
  'en-DK': {
    currency: {
      style: 'currency',
      currency: 'DKK',
      currencyDisplay: 'symbol',
    },
  },
  'en-EU': {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
    },
  },
  'en-AU': {
    currency: {
      style: 'currency',
      currency: 'AUD',
      currencyDisplay: 'symbol',
    },
  },
  'en-CA': {
    currency: {
      style: 'currency',
      currency: 'CAD',
      currencyDisplay: 'symbol',
    },
  },
  'en-MX': {
    currency: {
      style: 'currency',
      currency: 'MXN',
      currencyDisplay: 'symbol',
    },
  },
  'en-NG': {
    currency: {
      style: 'currency',
      currency: 'NGN',
      currencyDisplay: 'symbol',
    },
  },
  'en-KE': {
    currency: {
      style: 'currency',
      currency: 'KES',
      currencyDisplay: 'symbol',
    },
  },
};
